<div class="feedback-wrapper">
  <ok-feedback-info>
    <div>
      <p class="highlighted-text">
        @if (this.config().type === pricePolicyType.Dynamic) {
          Forbrugerpris - den pris som forbrugeren vil se på ladestanderen. Dynamisk pris vil inkludere nuværende elpris. Her vises bund og
          loft pris-spænd.
        } @else {
          Forbrugerpris - den pris som forbrugeren vil se på ladestanderen
        }
      </p>
      <div class="price-wrapper">
        <div class="price-column">
          <p class="highlighted-text">Ekskl. moms</p>
          <span>{{ displayExclVat() }}</span>
        </div>
        <div class="price-column">
          <p class="highlighted-text">Inkl. moms</p>
          <span>{{ displayInclVat() }}</span>
        </div>
      </div>
    </div>
  </ok-feedback-info>
</div>
